import { type ReactElement, type ReactNode } from "react"
import { useSelector } from "react-redux";
import { RootState } from "src/app/store";

export interface ExceptionEventCardProps {
        children?: ReactNode
}

export default function ExceptionEventCard(props: ExceptionEventCardProps): ReactElement {

        const { exceptionEventsLoading, exceptionEvents } = useSelector((state: RootState) => state.exceptionEvents);

        return <>
                < div className="flex flex-col w-full bg-[#00ffff] rounded-xs justify-center p-2">
                        <h3 className="sticky top-0 bg-blue-200 shadow-[0px_0px_5px_rgba(0,0,0,0.25)]">
                                <div className="grid grid-cols-6 p-4 font-semibold text-blue-700">
                                        <p className="text-center">Time</p>
                                        <p className="text-center">Name</p>
                                        <p className="text-center">Cloud Name</p>
                                        <p className="text-center">Location Name</p>
                                        <p className="text-center">Location Number</p>
                                        <p className="text-center">Location Status</p>
                                </div>
                        </h3>
                        {
                                !exceptionEventsLoading ?
                                        <>
                                                {
                                                        exceptionEvents.map((event) =>
                                                                <>
                                                                        <div className="grid grid-cols-6 pt-1 pb-1 items-center">
                                                                                <div className="text-center">
                                                                                        {event.DateTimeStamp}
                                                                                </div>
                                                                                <div className="text-center">
                                                                                        {event.EndUserName}
                                                                                </div>
                                                                                <div className="text-center">
                                                                                        {event.InstanceName}
                                                                                </div>
                                                                                <div className="text-center">
                                                                                        {event.LocationName}
                                                                                </div>
                                                                                <div className="text-center">
                                                                                        {event.LocationNumber}
                                                                                </div>
                                                                                <div className="text-center">
                                                                                        {event.LocationStatus ? "Up" : "Down"}
                                                                                </div>
                                                                        </div>
                                                                        <hr />
                                                                </>
                                                        )

                                                }
                                        </>
                                        :
                                        <></>
                        }
                </div>
        </>
}
